import ModuleBase, { moduleInit, ViewLayer, implementFunction, bindButtonClickEvent } from '../../../../framework/core/mvvm/module_base';
import AppData from '../../../public/const/app_data';
import ModelData, { IUserData } from '../../../public/model_data';
import ModuleManager from '../../../../framework/core/module_manager';
import Record from '../record/record';
import SceneManager from '../../../../manager/scene_manager';
import NotifyServer from "../../server/notify/notify_server";
import GoldEntranceMatchingView, { GoldRoomInfo, scene_type } from './goldentrance_matching_view';
import GoldRoomMatchingItem from './gold_room_matching_item';
import { GameManager } from '../../../../manager/game_manager';
import Rule from '../rule/rule';
import { NotifyData } from '../../../public/notify_data';
import { IUserCurrencyData } from '../../../../manager/user_manager';
import { joinUtil } from '../../../public/join_util';
import SlotRuleModule from '../../../slot/module/rule/slot_rule_module';
import LanguageManager from '../../../../manager/language_manager';
import Shop from '../shop/shop';

const { ccclass } = cc._decorator;

@ccclass
@moduleInit("GoldEntranceMatching")
export default class GoldEntranceMatching extends ModuleBase<GoldEntranceMatchingView, null> {

    clubChip = null
    chip = null;
    roldId : number ;

    private currentGame : string;
    //前置(大厅)动画
    private preTweenOver : boolean;

    private tweenOver : boolean;

    private httpData : any;

    private responDataMap : Map<number,any> = new Map();

    private gameData = {openChip:false,openGold:false};
    
    constructor() {
        super();
        this.modelType = null;
        this.windowPrefabResPath = "package/hall/module/goldentrance/hall_goldentrance_matching";
        this.viewType = GoldEntranceMatchingView;
    }

    onInit(intentData: any) {
        super.onInit(intentData);
        this.roldId = ModelData.instance.roleData.id;
                
        this.preTweenOver = false;
        this.tweenOver = false;
        //LoaclStorage.setItem("Module_xx_GoldEntranceMatching|" + this.roldId ,AppData.gameName);
    }
    
    onShow(intentData) {
        let self = this

        self.getUserData(ModelData.instance.roleData.id, (data: IUserData) => {
            self.view.setInfo(data)
        })
        this.getSelfCurrencyData(null, true);

        if (this.httpData) {
            //可能从其他游戏的场次进来 这里需更新一下
            joinUtil.updateRoomData(this.httpData.data);
        }

        SceneManager.lastEntranceOpenModuleName = "GoldEntranceMatching"
        // ModuleManager.instance.setModuleActive("HallBase", true)
        this.showLayerTop()
        if(intentData == "fromTable"){
            cc.log("从桌面返回的直接刷新refreshRecommendSession");
            this.view.refreshRecommendSession();
            this.view.checkRecharge();

            // let hallbase: HallBase = ModuleManager.instance.getModule("HallBase")
            // if (hallbase) {
            //     hallbase.isGoldEntranceShow()
            // }
            this.customCompleteCallback = null;

            this.preTweenOver = true;
            this.tweenOver = true;

        }else if (intentData == "HallShowGoldEntrance") {

            this.preTweenOver = false;
            this.tweenOver = false; 

            if (this.currentGame != AppData.gameName) {
                                
                this.currentGame = AppData.gameName;

                this.view.clear();
            }

            this.requestData(false);
                  
            this.node.active = false     
                  

        }else if( intentData == "ShowMango" ){

            this.preTweenOver = false;
            this.tweenOver = false; 

            this.changeScenePage(scene_type.mango);
            this.node.active = false            
        }

        if(!NotifyServer.instance.netClient.netState){
            this.connectNotifyServer();
        }
        self.view.changeTag(AppData.gameName);
        
        NotifyData.instance.changePlayerPos('hall',true)
    
    }

    onHide() {
        this.customCompleteCallback = null
    }

    @implementFunction('onSelfCurrencyDataUpdate')
    protected on_selfCurrencyDataUpdate(data: IUserCurrencyData){

        this.chip = data.chip;
        this.clubChip = data.chipClub;

        this.view.setGold(data)
             
        this.view.refreshRecommendSession(); 
       
        //货币变化检测充值
        // if (this.node.active && this.tweenOver) {
        //     this.view.checkRecharge();
        // }
    }

    tweenShowView(aniName) {
        this.setActive()

        let self = this;
        this.view.tweenTo(aniName,false,()=>{

            if (self.httpData) {
                self.view.checkRecharge();
            }
            self.tweenOver = true;
        });
        this.preTweenOver = true;
        this.checkUpdate();

    }


    connectNotifyServer() {
        NotifyServer.instance.connectServer(GameManager.notifyServer + ModelData.instance.roleData.id);
    }
    protected onButtonClickName(name: string, customEventData, item: cc.Node) {
        let self = this;
        switch (name) {
            case "BackBtn":
                SceneManager.lastEntranceOpenModuleName = ""
                SceneManager.showHall("OpenFromGoldEntranceModule", () => {
                    ModuleManager.instance.hideModule("GoldEntranceMatching");
                })
                break;
            case "RecordBtn":
                ModuleManager.instance.showModule(Record, "record")
                break;
            case "enterGame":
                var selectItem = item.parent.getComponent(GoldRoomMatchingItem);
                if(selectItem) {
                    let roomData = selectItem.info
                    if (roomData.openLevel && ModelData.instance.roleData.userLevel < roomData.openLevel) {
                        ModuleManager.instance.toast(LanguageManager.t("pubilc_levelLock").format(roomData.openLevel))
                        return
                    }

                    //判断钱够不够
                    // if (roomData.minJoinCoin > this.goldNum) {      
                    //     //筹码不足(场次最低限额{0}),  请选择合适的场次
                    //     let text = LanguageManager.t("join_coin_no_enough_tip").format(GameUtil.currencyFormat(roomData.minJoinCoin));
                    //     ModuleManager.instance.toast(text);
                    //     return
                    // }      
                    
                    // if (roomData.maxJoinCoin && roomData.maxJoinCoin < this.goldNum) {      

                    //     //筹码太多(场次最高限额{0}),  请选择合适的场次 
                    //     let text = LanguageManager.t("join_coin_exceed_tip").format(GameUtil.currencyFormat(roomData.maxJoinCoin));
                    //     ModuleManager.instance.toast(text);
                    //     return
                    // }
                    
                    joinUtil.joinMatch(roomData.goldData,this.chip);
                }
                break;
            case "HelpBtn":
                if(AppData.gameName == "TM_SLOT"){
                    ModuleManager.instance.showModule(SlotRuleModule)
                }else{
                    ModuleManager.instance.showModule(Rule, {isSys:false})
                }
                
                break;
            case "buttonLeft":
                //cc.log("self.view select0",self.view);
                self.view.changeBottomPage(0);
                    
                break;
            case "buttonRight":
                //cc.log("self.view select1",self.view);
                self.view.changeBottomPage(1);
                break;
            default:
                break;
        }
    }

    @bindButtonClickEvent("ButtonChip")
    onBUttonCurrencyChip() {
        ModuleManager.instance.showModule<Shop>(Shop, {tag: "tag_coin"})
    }


    public changeScenePage(sceneType : scene_type){

        this.view.changeScenePage(sceneType);
    }

    //TODO:如果回包很慢这个时候应该怎么办
    requestData(showNetPrompt) {
        let self = this
        this.view.reset();        
       
        let requestData: IHttpRequestData = {
            baseUrl: "gold/getGameGolds?",
            showNetPrompt: showNetPrompt,
            timeOutRequestMax : 1,
            encrypt:true
        }

        this.httpData = null;

        this.apiHttpGet(requestData, (respone) => {
            self.httpData = respone;
            self.checkUpdate();            
        })
    }

    checkUpdate(){

        cc.log(" checkUpdate tweenover : " + this.preTweenOver + " httpData " + this.httpData);

        if (this.preTweenOver && this.httpData) {
            
            joinUtil.updateRoomData(this.httpData.data);

            let refresh = false;
            let gameData = ModelData.instance.getGameDataShow(AppData.gameName);

            if (this.gameData.openChip != gameData.openChip || 
                this.gameData.openGold != gameData.openGold) {
             
                this.gameData.openChip = gameData.openChip;
                this.gameData.openGold = gameData.openGold;

                this.view.updateShow(this.httpData.data)   
                refresh = true;
            }
            else{

                for (let index = 0; index < this.httpData.data.length; index++) {
                    const data = this.httpData.data[index];
    
                    if (!this.responDataMap.has(data.gameGoldId)) {                    
                        this.view.updateShow(this.httpData.data)    
                        refresh = true;
                        break;                  
                    }
                }
            }

            if (refresh){

                this.responDataMap.clear();
                for (let index = 0; index < this.httpData.data.length; index++) {
                    const data = this.httpData.data[index];
                    this.responDataMap.set(data.gameGoldId,data);
                }
               
            }
            
            this.view.refreshRecommendSession();  

            if(this.tweenOver){

                this.view.checkRecharge();
            }                          
            
        }
    }
 


}
